import { FC } from 'react';
import { Menu } from 'antd';
import FieldResourcesIcon from 'app/containers/Task/icons/FieldResourcesIcon';
import { useTranslation } from 'react-i18next';
import { MenuInfo } from 'types';
import { SettingsTabKeyType } from '../../types';

interface IProps {
  selectedKey: string;
  onClickMenu: (clickedItem: MenuInfo) => void;
}

const SettingsTabs: FC<IProps> = ({ selectedKey, onClickMenu }) => {
  const { t } = useTranslation();

  const menuItems: {
    title: string;
    icon: JSX.Element;
    key: SettingsTabKeyType;
  }[] = [
    {
      title: t('Settings.Tabs.TaskCategories', 'Task categories'),
      icon: <FieldResourcesIcon />,

      key: 'taskCategories',
    },
  ];

  return (
    <Menu mode="inline" selectedKeys={[selectedKey]} onClick={onClickMenu}>
      {menuItems.map(item => (
        <Menu.Item icon={item.icon} key={item.key}>
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default SettingsTabs;
